import { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MyFetch } from "../../App";
import { useNavigate } from 'react-router-dom';
import Button from "react-bootstrap/esm/Button";


const EmployeeList = (props) => {
    const [list_Data, set_List_Data] = useState([])
    const navigate = useNavigate() 

    // useEffect(() => {
    //     fetch("https://easytasks.in/employee/list", {
    //         method: "GET",
    //         mode: "cors",
    //         headers: { "Accept": "application/json", "Content-Type": "application/json" },
    //     }).then((res) => res.json())
    //         .then((data) => set_List_Data(data))
    // }, [])

    useEffect(() => {
        MyFetch("https://easytasks.in/employee/list", {}, "GET")
            .then((res) => res.json())
            .then((data) => set_List_Data(data));
    }, [])
    
    const renderEmployee = (employee, index) => {
        return (
            
            <tr key={index}> 
                <td>{index}</td>
                <td>{employee.name}</td>
                <td>{employee.mobile}</td>
                <td>{employee.email}</td>
                <td>{employee.city}</td>
                <td>{employee.position}</td>
                <td>{employee.mode}</td>
                <td><Button variant="outline-secondary" onClick={()=>navigate('/employee/edit',{ state: { employeeid: employee.id } })}>Edit</Button></td>
            </tr>
        )
    };

    return (
        <Container className='mt-5'>
            <Row className="justify-content-md-left">
                <Col xs lg="5" >
                    <h2 className='my-5'><b>VIEW ALL EMPLOYEES</b></h2>
                </Col>
            </Row>
            <Table striped bordered hover size='sm'>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Mobile</th>
                        <th>Email</th>
                        <th>City</th>
                        <th>Position</th>
                        <th>Mode</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {/* {console.log(list_Data)} */}
                    {list_Data && list_Data.length > 0 ? list_Data.map(renderEmployee) : <></>}
                </tbody>
            </Table>
        </Container>
    )
}

export default EmployeeList;

// import { useState, useEffect } from "react";
// import Container from 'react-bootstrap/Container';
// import Table from 'react-bootstrap/Table';
// import Row from 'react-bootstrap/Row';
// import Col from 'react-bootstrap/Col';
// import { MyFetch } from "../../App";
// import { useNavigate } from 'react-router-dom';
// import Button from "react-bootstrap/esm/Button";

// const EmployeeList = (props) => {
//     const [list_Data, set_List_Data] = useState([]);
//     const [filteredData, setFilteredData] = useState([]);
//     const [sortConfig, setSortConfig] = useState({ key: '', direction: '' });
//     const [filterMode, setFilterMode] = useState('');
//     const navigate = useNavigate(); 

//     useEffect(() => {
//         MyFetch("https://easytasks.in/employee/list", {}, "GET")
//             .then((res) => res.json())
//             .then((data) => {
//                 set_List_Data(data);
//                 setFilteredData(data);
//             });
//     }, []);

//     const sortData = (key) => {
//         let direction = 'ascending';
//         if (sortConfig.key === key && sortConfig.direction === 'ascending') {
//             direction = 'descending';
//         }

//         const sortedData = [...filteredData].sort((a, b) => {
//             if (a[key] < b[key]) {
//                 return direction === 'ascending' ? -1 : 1;
//             }
//             if (a[key] > b[key]) {
//                 return direction === 'ascending' ? 1 : -1;
//             }
//             return 0;
//         });

//         setFilteredData(sortedData);
//         setSortConfig({ key, direction });
//     };

//     const renderSortIcon = (key) => {
//         if (sortConfig.key === key) {
//             return sortConfig.direction === 'ascending' ? ' ▲' : ' ▼';
//         }
//         return '';
//     };

//     const handleFilterChange = (event) => {
//         const value = event.target.value.toLowerCase();
//         setFilterMode(value);
//         const filtered = list_Data.filter((employee) =>
//             employee.mode.toLowerCase().includes(value)
//         );
//         setFilteredData(filtered);
//     };

//     const renderEmployee = (employee, index) => {
//         return (
//             <tr key={index}> 
//                 <td>{index}</td>
//                 <td>{employee.name}</td>
//                 <td>{employee.mobile}</td>
//                 <td>{employee.email}</td>
//                 <td>{employee.city}</td>
//                 <td>{employee.position}</td>
//                 <td>{employee.mode}</td>
//                 <td>{employee.totalPendingTasks}</td>
//                 <td>{employee.totalCompletedTasks}</td>
//                 <td><Button variant="outline-secondary" onClick={() => navigate('/employee/edit', { state: { employeeid: employee.id } })}>Edit</Button></td>
//             </tr>
//         );
//     };

//     return (
//         <Container className='mt-5'>
//             <Row className="justify-content-md-left">
//                 <Col xs lg="5">
//                     <h2 className='my-5'><b>VIEW ALL EMPLOYEES</b></h2>
//                 </Col>
//                 <Col xs lg="3">
//                     <input
//                         type="text"
//                         placeholder="Filter by mode"
//                         value={filterMode}
//                         onChange={handleFilterChange}
//                     />
//                 </Col>
//             </Row>
//             <Table striped bordered hover size='sm'>
//                 <thead>
//                     <tr>
//                         <th>#</th>
//                         <th onClick={() => sortData('name')}>Name{renderSortIcon('name')}</th>
//                         <th>Mobile</th>
//                         <th>Email</th>
//                         <th>City</th>
//                         <th>Position</th>
//                         <th onClick={() => sortData('mode')}>Mode{renderSortIcon('mode')}</th>
//                         <th onClick={() => sortData('totalPendingTasks')}>Total Pending Tasks{renderSortIcon('totalPendingTasks')}</th>
//                         <th onClick={() => sortData('totalCompletedTasks')}>Total Completed Tasks{renderSortIcon('totalCompletedTasks')}</th>
//                         <th>Action</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {filteredData && filteredData.length > 0 ? filteredData.map(renderEmployee) : <></>}
//                 </tbody>
//             </Table>
//         </Container>
//     );
// };

// export default EmployeeList;
